<template>
  <Component
    :is="maxSmall ? Drawer : Sheet"
    :variant="variant"
    :headerVariant="headerVariant"
    :open="open"
    :title="title"
    :description="description"
    :class="props.class"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <template v-if="$slots.trigger" #trigger>
      <slot name="trigger" />
    </template>
    <template v-if="$slots['header-start']" #header-start>
      <slot name="header-start" />
    </template>
    <template v-if="$slots['header-end']" #header-end>
      <slot name="header-end" />
    </template>
    <template v-if="$slots.content" #content>
      <slot name="content" />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </Component>
</template>

<script setup>
import { Drawer } from "@/Components/Drawer";
import { Sheet } from "@/Components/Sheet";
import { useBreakpoints } from "@/Composables/useBreakpoints";

defineEmits(["open", "close"]);

const props = defineProps({
  variant: { type: null, required: false },
  headerVariant: { type: null, required: false },
  open: { type: Boolean, default: undefined },
  title: { type: String, required: false },
  description: { type: String, required: false },
  class: { type: null, required: false },
});

const { maxSmall } = useBreakpoints();
</script>
